module.exports = "/_next/static/images/yazawa_inside-6ce94224e4764997f7f2c071f7aac93e.jpg";